import { render, staticRenderFns } from "./wbdp-long-tail.vue?vue&type=template&id=74050b93"
import script from "./wbdp-long-tail.vue?vue&type=script&lang=js"
export * from "./wbdp-long-tail.vue?vue&type=script&lang=js"
import style0 from "./wbdp-long-tail.vue?vue&type=style&index=0&id=74050b93&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports